<template>
    <div class="tile is-parent">
        <article class="tile is-child box">
            <p class="title">标题</p>
            <div class="block">
                <input class="input width-2" v-model="params.title"/>
            </div>
            <p class="title">开放时间</p>
            <div class="block">
                <el-date-picker
                        v-model="params.startTime"
                        type="datetime"
                        placeholder="开始时间"
                        align="right">
                </el-date-picker>
                <span class="r-top">~</span>
                <el-date-picker
                        v-model="params.endTime"
                        type="datetime"
                        placeholder="结束时间"
                        align="right">
                </el-date-picker>
            </div>
            <p class="title">全局-未领取到奖品时弹窗图片</p>
            <el-upload
                    class="avatar-uploader"
                    :action="server"
                    :show-file-list="false"
                    name="image"
                    :on-success="handleAvatarSuccess"
                    :before-upload="beforeAvatarUpload">
                <div class="info">
                    <el-button class="floatl" size="small" type="primary">点击上传</el-button><div  slot="tip" class="el-upload__tip floatl" style="color: red;font-size: 15px">只能上传jpg/png文件，且不超过500kb【建议宽高尺寸 600px * 764px】</div>
                </div>
                <image-component :image="params.image" :width="300"></image-component>
            </el-upload>
            <div class="block">
                <button class="button is-info" @click="saveEdit(1)">奖品配置</button>
                <button class="button is-info" @click="saveEdit(2)" style="margin-left: 30px;">规则配置</button>

            </div>
            <div class="block">
                <button class="button" @click="cancelEdit">取消</button>
                <button class="button is-info" @click="saveEdit(0)" style="margin-left: 30px;">保存</button>
            </div>
        </article>
    </div>
</template>
<script type="text/babel">
import { formatDate } from 'UTILS/date'
export default {
  data () {
    return {
      activityId: 0,
      params: {
        startTime: '',
        endTime: '',
        image: {
          image: '',
          width: 0,
          height: 0
        }
      }
    }
  },
  mounted: function () {
    this.$nextTick(function () {
      if (this.$route.query.activityId) {
        this.activityId = parseInt(this.$route.query.activityId)
      }
      if (this.activityId > 0) {
        this.getPriceTag()
      }
    })
  },
  computed: {
    server () {
      return process.env.VUE_APP_PLATFORM + '/admin.php?method=image.uploadImage'
    }
  },
  methods: {
    handleAvatarSuccess (response, file) {
      this.imageUrl = URL.createObjectURL(file.raw)
      this.params.image.image = response.data.images.info.path
      this.params.image.width = response.data.images.info.width
      this.params.image.height = response.data.images.info.height
    },
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg' || 'image/png'
      const isLt2M = file.size / 1024 < 500

      if (!isJPG) {
        this.$message('上传图片只能是 JPG/PNG 格式!')
      }
      if (!isLt2M) {
        this.$message('上传图片大小不能超过 500kb!')
      }
      return isJPG && isLt2M
    },
    // 获取专题分类详情
    getPriceTag () {
      HttpRequest.get('/admin.php?method=cartactivity.getActivity', {activityId: this.activityId}, true).then((response) => {
        this.params = response.data
        this.params.startTime = formatDate(response.data.startTime, 'yyyy-MM-dd hh:mm:ss')
        this.params.endTime = formatDate(response.data.endTime, 'yyyy-MM-dd hh:mm:ss')
      }, (response) => {
      })
    },

    // 保存编辑
    saveEdit (temp) {
      let params = Object.assign({}, this.params)
      params.activityId = this.activityId
      params.startTime = formatDate(new Date(params.startTime).getTime(), 'yyyy-MM-dd hh:mm:ss')
      params.endTime = formatDate(new Date(params.endTime).getTime(), 'yyyy-MM-dd hh:mm:ss')

      if (!params.title) {
        this.$message('请输入标题名称')
        return
      }
      if (!params.image.image) {
        this.$message('请上传图片')
        return
      }
      HttpRequest.post('/admin.php?method=cartactivity.doSaveActivity', params, true).then((response) => {
        if (response.data.success == 1) {
          this.$message('保存成功', 1000)
          setTimeout(() => {
            if (temp == 0) {
              this.$router.push({name: 'addCartPrize'})
            }
            if (temp == 1) {
              this.$router.push({name: 'addCartPrizeConfig', query: {activityId: response.data.activityId}})
            }
            if (temp == 2) {
              this.$router.push({name: 'addCartRuleConfig', query: {activityId: response.data.activityId}})
            }
          })
        }
      }, (response) => {

      })
    },
    cancelEdit () {
      this.$router.push({name: 'addCartPrize'})
    }
  }
}
</script>
<style lang="less" scoped>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
    .info{
        height:35px;
        .floatl{
          float: left;
        }
    }
</style>
